import * as React from 'react';

import { Action, Dispatch, bindActionCreators } from 'redux';
import { Dropdown, DropdownMenuItemType, IDropdownOption } from '@fluentui/react';

import { AsyncData } from '../../redux/core';
import { ProviderSchedules } from '../../redux/providers/types';
import { RootState } from '../../redux/types';
import { connect } from 'react-redux';
import { setProvider } from '../../redux/ui/actions';

export interface StateProps {
  markets: string[];
  marketToProviderSchedules: { [market: string]: AsyncData<ProviderSchedules[]> };
  selectedProviderId: string;
}

export interface DispatchProps {
  actions: {
    setProvider: (provider: any) => void;
  };
}

type ProviderSelectorProps = StateProps & DispatchProps;

class Component extends React.Component<ProviderSelectorProps> {
  public render(): JSX.Element | null {
    if (this.props.markets.length === 0) {
      return null;
    }

    const options: any[] = [];
    this.props.markets!.forEach((market) => {
      options.push({
        key: market,
        text: market,
        itemType: DropdownMenuItemType.Header,
      });
      const providerSchedule = this.props.marketToProviderSchedules[market];
      if (!providerSchedule || providerSchedule.isFetching) {
        options.push({
          key: `LOADING_${market}`,
          text: 'Loading...',
        });
      } else if (providerSchedule.data) {
        options.push(
          ...providerSchedule.data!.map((p) => {
            return { key: p.provider.id, text: p.provider.fullName };
          })
        );
      }
    });

    return (
      <Dropdown
        placeholder="Select providers"
        style={{ width: 170 }}
        selectedKey={this.props.selectedProviderId}
        options={options}
        onChange={this.onChange}
        data-tid="dd_provider"
      />
    );
  }

  private onChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if ((option!.key as string).indexOf('LOADING') === 0) {
      return;
    }
    this.props.actions.setProvider(option!.key as string);
  };
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    markets: state.ui.markets,
    marketToProviderSchedules: state.providers.marketToProviderSchedules,
    selectedProviderId: state.ui.providerId,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
  return {
    actions: bindActionCreators({ setProvider }, dispatch),
  };
};

export const ProviderSelector = connect(mapStateToProps, mapDispatchToProps)(Component);
